import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";


export class ViewPortfolioSummaryModule extends ModuleProto {
    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_PORTFOLIO_SUMMARY, moduleConfig);

        this.name                       = "Portfolio Summary"
        this.description                = "The Summary View offers a consolidated overview of multiple projects, highlighting key metrics, progress, and high-level insights across the project portfolio. It enables users to monitor timelines, milestones, statuses, and workload distribution in one place, making it easier to track overall performance and spot potential issues."
        this.svgIcon                    = "isvg-view-summary"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-portfolio-summary"
        this.canDisable                 = false
        this._isEnabled                 = true
        this.parentSection              = SettingsParentSection.VIEWS

    }

    toJson() {
        const result = super.toJson();
        return result
    }
}
